"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../Constant");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  stroke: ", ";\n  fill: none;\n  stroke-width: 2.4;\n  stroke-linecap: butt;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: block;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var CircleSvg = _styledComponents.default.svg(_templateObject());

var CirclePath = _styledComponents.default.path(_templateObject2(), function (_ref) {
  var color = _ref.color;
  return color;
});

var CIRCLE_PATH = "M18 2.0845\n   a 15.9155 15.9155 0 0 1 0 31.831\n   a 15.9155 15.9155 0 0 1 0 -31.831";
/**
 * A circle progress/graph mostly copied from https://codepen.io/sergiopedercini/pen/aWawra
 *
 * Stretches to fit the parent container's height.
 */

var ProgressCircle = function ProgressCircle(_ref2) {
  var color = _ref2.color,
      value = _ref2.value,
      rest = (0, _objectWithoutProperties2.default)(_ref2, ["color", "value"]);
  return /*#__PURE__*/_react.default.createElement(CircleSvg, (0, _extends2.default)({
    viewBox: "0 0 36 36"
  }, rest), /*#__PURE__*/_react.default.createElement(CirclePath, {
    color: _Constant.Color.LINE_GREY,
    strokeDasharray: "100, 100",
    d: CIRCLE_PATH
  }), /*#__PURE__*/_react.default.createElement(CirclePath, {
    color: color,
    strokeDasharray: "".concat(value, ", 100"),
    d: CIRCLE_PATH
  }));
};

ProgressCircle.propTypes = {
  /** The color to render the progress portion of the circle */
  color: _propTypes.default.string,

  /** The percentage of the circle to fill, a 0 to 100 value */
  value: _propTypes.default.number
};
ProgressCircle.defaultProps = {
  color: "".concat(_Constant.Color.TEAL),
  value: 0
};
var _default = ProgressCircle;
exports.default = _default;